










































import Vue from 'vue'
import { YEXT_AVAILABLE_IN_COUNTRIES, YEXT_PUBLISHER_AS_PER_COUNTRY } from '../../../util/constants';
export default Vue.extend({
  props: {
    location: {
      type: Object,
    },
    company: {
      type: Object,
    },
    user: {
      type: Object,
    },
  },
  computed: {
    showYextOption() {
      try {
        if (
          this.user.permissions.online_listings_enabled !== false &&
          this.company &&
          this.location &&
          YEXT_AVAILABLE_IN_COUNTRIES.includes(this.company?.country) &&
          YEXT_AVAILABLE_IN_COUNTRIES.includes(this.location?.country) &&
          this.company.stripeConnectId &&
          this.location.yextReseller &&
          this.location.yextReseller.location_enabled
        ) {
          return true
        }
      } catch (err) {
        console.error(err)
      }
      return false
    },

    yextId() {
      if (this.location) {
        return this.location.yextId || this.location.yextReseller.location_id
      }
    },

  },
  methods: {
    gotoYextPitch() {
      this.$router.push({ name: 'reputation_listing' })
    },
     noOfListings: function () {
      return YEXT_PUBLISHER_AS_PER_COUNTRY[this.location.country]
    },
  },
})
